module.exports = __webpack_public_path__ + "media/images/Resolucion-No-Cair-147f0cdfa256ec5bcedf0a63a4f6846f.png";